import { Link } from 'react-router-dom';
import ContactForm from '@features/home/ContactForm';
import InfoSection from '@features/home/InfoSection';
import ProductsSection from '@features/home/ProductsSection';


const Home = () => {


  const sections = [
    {
      imageSrc: "https://cdn.builder.io/api/v1/image/assets/TEMP/2653d90531c2e780d3dbb57df887ab2aa716e65300ef5ef5ea895a4fad4bf01d?apiKey=e11f1c3e4c454432a22c0ca424050c32&",
      altText: "Huter product",
      imageClass: "bg-zinc-900",
      descr: "HUTER is your trusted partner in the world of electrical equipment. We are dedicated to providing customers with affordable and high-quality products that help them accomplish various tasks, including gardening, snow removal, and maintaining order around their properties."
    },
    {
      imageSrc: "https://cdn.builder.io/api/v1/image/assets/TEMP/f5954bbb5276d59bcdd878fe22aad569d32b4fb94915b624f33f4cceec6175c2?apiKey=e11f1c3e4c454432a22c0ca424050c32&",
      altText: "Huter product",
      imageClass: "bg-yellow-300",
      descr: "HUTER carefully selects only the highest quality materials from trusted suppliers to ensure that our products are of the best possible quality and durability. Our team of experts is always available to help you choose the right equipment for your needs, providing advice and recommendations based on your specific requirements."
    },
    {
      imageSrc: "https://cdn.builder.io/api/v1/image/assets/TEMP/3e1892aac491cf01e93376d3e4d67e62adac2d059ad5519497e80d114f896890?apiKey=e11f1c3e4c454432a22c0ca424050c32&",
      altText: "Huter product",
      imageClass: "bg-amber-800",
      descr: "At HUTER, we aim to exceed your expectations by offering not only exceptional equipment, but also exceptional customer service. We are committed to ensuring that each customer leaves our store satisfied with their purchase, and we encourage them to return for future needs."
    },
  ];


  return (
    <>
      <div className="overflow-hidden py-[119px] bg-white">
        <div className="flex gap-5 max-md:gap-10 max-sm:flex-col w-full max-w-[1290px] mx-auto">
          <div className="flex flex-col w-[42%] max-md:w-6/12 max-sm:w-full">
            <div className="flex flex-col w-full font-bold text-black">
              <h1 className="text-7xl leading-[101px] max-md:text-6xl max-md:leading-[72px] max-sm:text-4xl max-sm:leading-[52px]">
                The official representative of
                <span className="text-yellow-400"> HUTER</span>
              </h1>
              <p className="mt-5 text-2xl leading-snug max-md:mt-8 max-md:text-xl max-sm:text-lg">
                Huter is a globally recognized brand that constantly updates its product line with the latest technological innovations, offering customers the most advanced solutions available.
              </p>
              <button className="flex gap-2.5 items-center self-start px-12 py-2.5 mt-10 bg-yellow-400 rounded-3xl cursor-pointer duration-[0.2s] min-h-[57px] transition-[background-color]">
                <Link to="/catalog">
                  <span className="text-xl font-bold">Catalog</span>
                </Link>
              </button>
            </div>
          </div>
          <div className="flex flex-col ml-5 w-[58%] max-md:w-6/12 max-sm:w-full">
            <div className="flex overflow-hidden flex-col grow mt-3.5 w-full p-[30px] rounded-3xl max-sm:mt-8">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/124f2a1a734c4b04c59661b229c4acd2ab9a10d27ce1dd2d521031ae0e19db19?apiKey=e11f1c3e4c454432a22c0ca424050c32&"
                alt=""
                className="object-cover w-full aspect-[1.31] border-4 border-yellow-400 border-solid rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col py-13 mb-[125px] mx-auto my-0 max-w-[1290px] max-sm:p-5" id="about-huter">
        <h1 className="mb-32 text-6xl font-bold text-black max-md:mb-15 max-md:text-5xl max-sm:mb-10 max-sm:text-4xl bg-yellow-400 px-12 py-7 rounded-2xl w-fit">
          About Huter
        </h1>
        <div className="flex flex-col max-sm:flex-col-reverse">
          {sections.map((section, index) => (
            <InfoSection
              key={index}
              specNum={index}
              imageSrc={section.imageSrc}
              description={section.descr}
              altText={section.altText}
              imageClass={section.imageClass}
            />
          ))}
        </div>
      </div>


      <ProductsSection />


      <ContactForm />









    </>
  )
}

export default Home